import { useIonRouter } from '@ionic/react';

const useLogout = () => {
  const router = useIonRouter();

  const logout = () => {
    // 1. Clear Authentication Tokens/Data
    localStorage.removeItem('token'); // Or use a more specific key
    // sessionStorage.removeItem('...'); // If you use session storage

    // 2. Redirect to Login Page
    router.push('/login', 'root'); // Use 'root' to prevent going back

    // 3. (Optional) Show a Toast/Alert
    // You can use useIonToast or useIonAlert to display a message
    // indicating successful logout.
  };

  return { logout };
};

export default useLogout;